import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LinkBraun from '../common/LinkBraun';
import LoadingScreen from '../LoadingScreen';
import Typography from '../common/Typography';

import data from '../data';

import styles from './styles.module.css';

export default function LandingPage({ showNext }) {
  const [visible, setVisible] = useState(false);

  const { general } = data;

  const hideElements = () => {
    setVisible(false);
    showNext();
  };
  return (
    <>
      <LoadingScreen onComplete={() => setVisible(true)} />
      {visible && (
        <div className={styles.container}>
          <div className={styles.logoContainer}>
            <img
              alt="100 years"
              src="https://res.cloudinary.com/arts/image/upload/b_rgb:000000,c_scale,w_672/v1599635869/max-braun/intro/Braun_100yrs.jpg"
            />
            <LinkBraun onClick={hideElements} text={general.startExperience} />
          </div>

          <div className={styles.headphones}>
            <svg
              className={styles.audio}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21.65 20.25"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="M10.8,0A10.76,10.76,0,0,0,3.25,3.2,10.83,10.83,0,0,0,0,11v6.5a2.64,2.64,0,0,0,.75,1.95,2.72,2.72,0,0,0,2,.8H4a2,2,0,0,0,.8-.15,2.11,2.11,0,0,0,1.1-.65,2,2,0,0,0,.65-1.25,1.54,1.54,0,0,0,.15-.7V14.25a2.9,2.9,0,0,0-.8-1.95A2.84,2.84,0,0,0,4,11.5H2.55V11A8.49,8.49,0,0,1,5,5a8.35,8.35,0,0,1,5.8-2.45A8.06,8.06,0,0,1,16.55,5,8.39,8.39,0,0,1,19,11v.5H17.65a2.61,2.61,0,0,0-1.9.8A2.87,2.87,0,0,0,15,14.25V18.2a2.8,2.8,0,0,0,.75,1.25,1.85,1.85,0,0,0,1,.65,2.83,2.83,0,0,0,.9.15H19a2.45,2.45,0,0,0,1.85-.8,2.64,2.64,0,0,0,.75-1.95v-6l.1-.5A10.83,10.83,0,0,0,18.4,3.2,10.93,10.93,0,0,0,10.8,0Z"
                      style={{ fill: '#fff' }}
                    />
                  </g>
                </g>
              </g>
            </svg>

            <Typography
              component="div"
              dangerouslySetInnerHTML={{ __html: general.headPhones }}
            />
          </div>
        </div>
      )}
    </>
  );
}

LandingPage.propTypes = {
  showNext: PropTypes.func,
};
